<template>
  <div>
    <v-card class="primary darken-2 elevation-0">
      <v-window v-model="step">
        <v-window-item :value="1">
          <v-container>
            <v-row>
              <v-col v-if="$vuetify.breakpoint.name !== 'xs'" sm="6" md="7" lg="7" xl="7">
                <div style="border-color: white; border-style: solid; border-radius: 7px">
                  <v-col cols="12" align-self="center" align="center">
<!--                      <v-icon small>mdi-checkbox-blank-circle-outline</v-icon>
                      <v-icon small>mdi-checkbox-blank-circle-outline</v-icon>
                      <v-icon small>mdi-checkbox-blank-circle-outline</v-icon>
                      <v-icon small class="mr-0 ml-2">mdi-chevron-left-box-outline</v-icon>
                      <v-icon small class="mr-16 ml-0">mdi-chevron-right-box-outline</v-icon>-->
                      <v-btn class="mt-n4" outlined color="white" x-small style="border-radius: 5px;cursor: none; pointer-events: none;">infohidro.simepar.br/</v-btn>
                  </v-col>
                  <v-divider class="mt-n3" color="white"></v-divider>
                  <iframe
                    style="border:none"
                    :allowfullscreen="false"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    width="100%"
                    height="385"
                    src="https://www.youtube.com/embed/t2PFBy_WuDM?version=3&loop=1&playlist=t2PFBy_WuDM&autoplay=1&controls=0&showinfo=0&rel=0&mute=1;"
                  ></iframe>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                <v-card-title class="mt-n5">
                  <span class="infoHidro">SOBRE O INFOHIDRO</span>
                </v-card-title>
                <v-card-title class="mt-n7">
                  <span class="titleForm" style="word-break: break-word;">
                    Monitoramento dos mananciais de captação e de lançamentos de efluentes.
                  </span>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <v-icon color="secondary lighten-1" left class="mt-n1">mdi-checkbox-marked-circle-outline</v-icon>
                      <span class="subtitleForm">
                        Previsões específicas para os mananciais da Sanepar
                      </span>
                    </v-col>
                    <v-col cols="12">
                      <v-icon color="secondary lighten-1" left class="mt-n1">mdi-checkbox-marked-circle-outline</v-icon>
                      <span class="subtitleForm">
                        Dados hidrológicos em gráficos
                      </span>
                    </v-col>
                    <v-col cols="12">
                      <v-icon color="secondary lighten-1" left class="mt-n1">mdi-checkbox-marked-circle-outline</v-icon>
                      <span class="subtitleForm">
                        Experiências de uso voltadas às atividades operacionais
                      </span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-window-item>
        <v-window-item :value="2">
          <v-container>
            <v-row>
              <v-col v-if="$vuetify.breakpoint.name !== 'xs'" sm="6" md="7" lg="7" xl="7">
                <div style="border-color: white; border-style: solid; border-radius: 7px">
                  <v-col cols="12" align-self="center" align="center">
                    <v-btn class="mt-n4" outlined color="white" x-small style="border-radius: 5px;cursor: none; pointer-events: none;">infohidro.simepar.br/</v-btn>
                  </v-col>
                  <v-divider class="mt-n3" color="white"></v-divider>
                  <iframe
                    style="border:none"
                    :allowfullscreen="false"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    width="100%"
                    height="385"
                    src="https://www.youtube.com/embed/OcR6aKSmZ40?version=3&loop=1&playlist=OcR6aKSmZ40&autoplay=1&controls=0&showinfo=0&rel=0&mute=1;"
                  ></iframe>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                <v-card-title class="mt-n5">
                  <span class="infoHidro">SOBRE O INFOHIDRO</span>
                </v-card-title>
                <v-card-title class="mt-n7">
                  <span class="titleForm" style="word-break: break-word;">
                    Situação dos reservatórios e do sistema de abastecimento de água.
                  </span>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <v-icon color="secondary lighten-1" left class="mt-n1">mdi-checkbox-marked-circle-outline</v-icon>
                      <span class="subtitleForm">
                        Análise gráfica das cotas dos reservatórios
                      </span>
                    </v-col>
                    <v-col cols="12">
                      <v-icon color="secondary lighten-1" left class="mt-n1">mdi-checkbox-marked-circle-outline</v-icon>
                      <span class="subtitleForm">
                        Dados de precipitação das bacias de contribuição
                      </span>
                    </v-col>
                    <v-col cols="12">
                      <v-icon color="secondary lighten-1" left class="mt-n1">mdi-checkbox-marked-circle-outline</v-icon>
                      <span class="subtitleForm">
                        Dados de nível dos reservatórios
                      </span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-window-item>
        <v-window-item :value="3">
          <v-container>
            <v-row>
              <v-col v-if="$vuetify.breakpoint.name !== 'xs'" sm="6" md="7" lg="7" xl="7">
                <div style="border-color: white; border-style: solid; border-radius: 7px">
                  <v-col cols="12" align-self="center" align="center">
                    <v-btn class="mt-n4" outlined color="white" x-small style="border-radius: 5px;cursor: none; pointer-events: none;">infohidro.simepar.br/</v-btn>
                  </v-col>
                  <v-divider class="mt-n3" color="white"></v-divider>
                  <iframe
                    style="border:none"
                    :allowfullscreen="false"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    width="100%"
                    height="385"
                    src="https://www.youtube.com/embed/dT2nbwxQijY?version=3&loop=1&playlist=dT2nbwxQijY&autoplay=1&controls=0&showinfo=0&rel=0&mute=1;"
                  ></iframe>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                <v-card-title class="mt-n5">
                  <span class="infoHidro">SOBRE O INFOHIDRO</span>
                </v-card-title>
                <v-card-title class="mt-n7">
                  <span class="titleForm" style="word-break: break-word;">
                    Monitoramento ambiental.
                  </span>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <v-icon color="secondary lighten-1" left class="mt-n1">mdi-checkbox-marked-circle-outline</v-icon>
                      <span class="subtitleForm">
                        Evolução do uso e cobertura da terra da área dos mananciais
                      </span>
                    </v-col>
                    <v-col cols="12">
                      <v-icon color="secondary lighten-1" left class="mt-n1">mdi-checkbox-marked-circle-outline</v-icon>
                      <span class="subtitleForm">
                        Monitoramento de riscos de incêndio e focos de calor
                      </span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-window-item>
        <v-window-item :value="4">
          <v-container>
            <v-row>
              <v-col v-if="$vuetify.breakpoint.name !== 'xs'" sm="6" md="7" lg="7" xl="7">
                <div style="border-color: white; border-style: solid; border-radius: 7px">
                  <v-col cols="12" align-self="center" align="center">
                    <v-btn class="mt-n4" outlined color="white" x-small style="border-radius: 5px;cursor: none; pointer-events: none;">infohidro.simepar.br/</v-btn>
                  </v-col>
                  <v-divider class="mt-n3" color="white"></v-divider>
                  <iframe
                    style="border:none"
                    :allowfullscreen="false"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    width="100%"
                    height="385"
                    src="https://www.youtube.com/embed/XGtfZUxOgNk?version=3&loop=1&playlist=XGtfZUxOgNk&autoplay=1&controls=0&showinfo=0&rel=0&mute=1;"
                  ></iframe>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                <v-card-title class="mt-n5">
                  <span class="infoHidro">SOBRE O INFOHIDRO</span>
                </v-card-title>
                <v-card-title class="mt-n7">
                  <span class="titleForm" style="word-break: break-word;">
                    Dados de estações hidrológicas e pluviométricas.
                  </span>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <v-icon color="secondary lighten-1" left class="mt-n1">mdi-checkbox-marked-circle-outline</v-icon>
                      <span class="subtitleForm">
                        Estações em diversas regiões do Paraná
                      </span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-window-item>
      </v-window>
      <v-card-actions v-if="$vuetify.breakpoint.name === 'xs'" class="mt-n8 mr-11">
        <v-btn
          :disabled="step === 1"
          text
          color="secondary lighten-1"
          @click="step--"
        >
          <v-icon>mdi-chevron-left</v-icon>
          voltar
        </v-btn>
        <v-btn
          :disabled="step === 4"
          color="secondary lighten-1"
          text
          @click="step++"
        >
          avançar
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
      <v-card-actions v-else-if="$vuetify.breakpoint.name === 'sm'" class="mt-n11 mr-11">
        <v-spacer />
        <v-spacer />
        <v-spacer />
        <v-btn
          :disabled="step === 1"
          text
          color="secondary lighten-1"
          @click="step--"
        >
          <v-icon>mdi-chevron-left</v-icon>
          voltar
        </v-btn>
        <v-btn
          :disabled="step === 4"
          color="secondary lighten-1"
          text
          @click="step++"
        >
          avançar
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
      <v-card-actions v-else class="mt-n12 mr-11">
        <v-spacer />
        <v-spacer />
        <v-spacer />
        <v-btn
          :disabled="step === 1"
          text
          color="secondary lighten-1"
          @click="step--"
        >
          <v-icon>mdi-chevron-left</v-icon>
          voltar
        </v-btn>
        <v-btn
          :disabled="step === 4"
          color="secondary lighten-1"
          text
          @click="step++"
        >
          avançar
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "About",
  data(){
    return{
      step: 1,
    }
  },
}
</script>

<style scoped>
.infoHidro{
  font-family: "Poppins", sans-serif !important;
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  line-height: 24px;
  color: #95A1EC;
}
.subtitleForm {
  font-family: "Poppins", sans-serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 24px;
}

.titleForm {
  font-family: "Questrial", sans-serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 2.25rem;
  line-height: 37px;
}
.v-btn{
  text-transform: none;
  font-size: 1rem;
}
</style>
